class AbstractInputListener{

    selector;
    operations_interface;

    constructor(selector, operations_interface = null) {
        this.selector = selector;
        this.operations_interface = operations_interface;

        this.listen();
    }

    listen()
    {

    }

}